module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("application-confirmation-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "bulk-import-confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "backdrop": false,
      "width": "1100px",
      "value": _vm.showModal,
      "v-if": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.userDepartment))])])]), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-body bulk-import-confirmation-modal-body overflow-modal-body",
    style: ('height:600px' + ';padding: 5px 15px; ')
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("申請者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  })]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.teamApplicant))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userApplicant))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("承認者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  })]), _vm._v(" "), _vm._l((_vm.ApprovalNumberSet), function(n) {
    return _c('tr', {
      key: n
    }, [_c('td', [_vm._v(_vm._s(n) + ".")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": _vm.lastChange
      }
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['team_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['team_' + n].id]
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['approver_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['approver_' + n].id]
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['status_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['status_' + n].id]
      }
    })], 1)])])
  }), _vm._v(" "), (_vm.applicationMode != 'mode_inventory') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "col-xs-13"
  }, [_vm._v("最終承認")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-13"
  }, [_vm._v("ライセンス管理窓口（最終承認）")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col5), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col6), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer no_focus",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.application_mode != 'inventory') ? _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.approvalHistoryTorokuNumber))]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalIsReadOnly != true),
      expression: "modalIsReadOnly != true"
    }],
    class: 'btn btn-primary ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disableBtnApply,
      "type": "button"
    },
    on: {
      "click": _vm.onLocalApplication
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "applicationConfirmatioModal"
    },
    on: {
      "done": _vm.onSaveApplicationConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformation"
    },
    on: {
      "done": _vm.onSave
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5abdafec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/application-confirmation-modal-inventory.vue
// module id = 1000
// module chunks = 0